<template>
  <div style="display: inline">
    <v-btn
      icon
      @click.stop="dialog = true;"
    >
      <v-icon>mdi-key</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
      <ChangeUserPasswordForm 
        v-if="dialog"
        :connection="connection"
        :user="user"
        @cancel="dialog = false"
        @ok="dialog = false"
        @users-updated="$emit('users-updated', $event)"
        @failure="$emit('failure', $event)"
      ></ChangeUserPasswordForm>
    </v-dialog>
  </div>
</template>

<script>
import ChangeUserPasswordForm from "./ChangeUserPasswordForm";

export default {
  name:       "ChangeUserPassword",
  components: { ChangeUserPasswordForm },
  props:      ["connection", "user"],
  data:       () => ({
    dialog: false
  })
}
</script>

<style scoped>
</style>
